// import { DashboardOutlined, Person, Search, BusinessIcon, WorkIcon, SearchIcon, ModeStandbyIcon, CalendarMonthIcon, StorageIcon, ThumbUpIcon } from '@mui/icons-material';

import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import InsertInvitationOutlinedIcon from '@mui/icons-material/InsertInvitationOutlined';
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';

import {DrawPersonIcon } from '../../../data/SVGs';
import i18n from '../../../Utils/i18n';

const getNavbarListExpert = (inviterEsnId) => {
    console.log('inviterEsnId',inviterEsnId);

    return [
        inviterEsnId==false ? {
            icon: HomeOutlinedIcon,
            desc: i18n.t('Tableau de bord'),
            secondDesc: '',
            badge: 0,
            subList: [],
            link: 'dashbordExpert'
        }: null,
        {
            icon: DrawPersonIcon,
            desc: i18n.t('Mon Compte'),
            secondDesc: '',
            badge: 0,
            subList: [
                {
                    desc: i18n.t('Données profil'),
                    badge: 0,
                    link: 'donneeProfile'
                },
                {
                    desc: i18n.t('Documents administratifs'),
                    badge: 0,
                    link: 'docAdministrative'
                },
                {
                    desc: i18n.t('Paramètres de compte'),
                    badge: 0,
                    link: 'parametreCompte'
                },
                //{
                //    desc: 'Messages',
                //    badge: 10,
                //    link: 'conversation'
                //},

            // {
            //     desc: 'Se déconnecter',
            //     badge: 11,
            //     link: 'deconnecter'
            // },
            ],
        },
        inviterEsnId==false ? {
            icon: WorkOutlineOutlinedIcon,
            desc: i18n.t('Appels d\'offres'),
            secondDesc: '',
            badge: 0,
            subList: [
                {
                    desc: i18n.t('Rechercher un AO'),
                    badge: 0,
                    link: ''
                },
                {
                    desc: i18n.t('Mes candidatures'),
                    badge: 0,
                    link: 'candidatures'
                },
                //{
                //    desc: 'Mes RDV',
                //    badge: 0,
                //    link: 'gestionRDV'
                //},
                {
                    desc: i18n.t('Mes favoris'),
                    badge: 0,
                    link: 'aosFavoris'
                },
            //{
            //    desc: 'Mes alertes',
            //    badge: 0,
            //    link: 'alertes'
            //},
            ]} : null,
        {
            icon: InsertInvitationOutlinedIcon,
            desc: i18n.t('Mes RDV'),
            secondDesc: '',
            badge: 0,
            subList: [],
            link: 'gestionRDV'
        },
        inviterEsnId==true ?
            {
                icon: AssignmentOutlinedIcon,
                desc: i18n.t('Mes missions'),
                secondDesc: '',
                badge: 0,
                link: 'mission' ,
                subList: []
            }:null,
        inviterEsnId==false ?
            {
                icon: AssignmentOutlinedIcon,
                desc: i18n.t('Missions et BDC'),
                secondDesc: '',
                badge: 0,
                subList: [
                    {
                        desc: i18n.t('Ordres de mission'),
                        badge: 0,
                        link: 'ordreMission'
                    },
                    {
                        desc: i18n.t('Les missions & Bons de commande'),
                        badge: 0,
                        link: 'mission'
                    },
                ],
            }:null,
        inviterEsnId==true ?
            {
                icon: AssignmentOutlinedIcon,
                desc: i18n.t('Mes CRA'),
                secondDesc: '',
                badge: 0,
                link: 'AllCras' ,
                subList: []
            }:null,
        inviterEsnId==false ?
            {
                icon: InventoryOutlinedIcon,
                desc: i18n.t('CRA & Factures'),
                secondDesc: '',
                badge: 0,
                subList: [
                    {
                        desc: i18n.t('Compte rendu d\'activité'),
                        badge: 2,
                        link: 'AllCras'
                    },
                    {
                        desc: i18n.t('Factures'),
                        badge: 0,
                        link: 'AllFactures'
                    },
                ]
            }:null,
        //{
        //    icon: DrawOutilSuiviIcons,
        //    desc: 'Outil suivi',
        //    secondDesc: '',
        //    badge: 0,
        //    subList: [],
        //},

    //{
    //    icon: ThumbUpOutlinedIcon,
    //    desc: 'Références',
    //    secondDesc: '',
    //    badge: 0,
    //    subList: [],
    //},
    ].filter(item => item !== null);  // Filters out any falsy values;
};
export default getNavbarListExpert;
